import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';



@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(
        
        ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if account is logged in and request is to the api url
            request = request.clone({
              setHeaders: {
                'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem(localStorage.getItem('azureauthtoken')))?.secret
            }
            });
        

        return next.handle(request);
    }
}
